import React, { useEffect, useState } from "react";
import { Badge, Card, Col, Form, Offcanvas, Row, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsKitPreparationServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitPreparationServices";
import { eiwrsKitQuanrantineReasonServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitQuanrantineReasonServices";
import { FaLock } from "react-icons/fa";

const QuarantinedKitPreparation = ({
  kitData,
  getStudyKitInventory,
  Show,
  Hide,
  Title,
  columns,
  setKitId,
  eiwrsPermission
}) => {
  const { studyId } = useParams()
  const [reasonType, setReasonType] = useState("dynamic");
  const [reasonList, setReasonList] = useState([]);
  const [quarantinedReason, setQuarantinedReason] = useState("");
  const [investigationNumber, setInvestigationNumber] = useState("");
  const [quarantinedComment, setQuarantinedComment] = useState("");
  const [checkbox, setCheckbox] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const getEIWRSKitQuanrantineReasonData = async () => {
    let data = await eiwrsKitQuanrantineReasonServices.getEIWRSKitQuanrantineReasonData("active", studyId)
    setReasonList(data?.data || [])
  }

  useEffect(() => {
    getEIWRSKitQuanrantineReasonData()
  }, []);

  const statusQuarantinedConvertKitPreparation = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Quarantine Kit!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, quarantine it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = kitData?._id;
        userData.studyId = studyId;
        userData.status = "quarantined";
        userData.quarantinedReason = quarantinedReason;
        userData.investigationNumber = investigationNumber;
        userData.quarantinedComment = quarantinedComment;
        let data = await eiwrsKitPreparationServices.statusConvertKitPreparation(
          userData
        );
        if (data?.statusCode === 200) {
          getStudyKitInventory();
          Hide();
          setQuarantinedReason("");
          setInvestigationNumber("");
          setQuarantinedComment("");
        }
      }
      setButtonLoader(false);
    });
  };

  const statusReleasedQuarantinedConvertKitPreparation = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Release from Quarantine Kit!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Release it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = kitData?._id;
        userData.studyId = studyId;
        userData.status = "releaseQuarantined";
        let data = await eiwrsKitPreparationServices.statusConvertKitPreparation(
          userData
        );
        if (data?.statusCode === 200) {
          getStudyKitInventory();
          Hide();
          setQuarantinedReason("");
          setInvestigationNumber("");
          setQuarantinedComment("");
        }
      }
      setButtonLoader(false);
    });
  };
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="mb-3">
            <Card.Body>
              <Row>
                {kitData?.kitNumber &&
                  <Col xs={6}>
                    <div className="text-muted small">Kit Number</div>
                    <Form.Label className="text-capitalize">{kitData?.kitNumber}</Form.Label>
                  </Col>
                }
                {kitData?.kitType &&
                  <Col xs={6}>
                    <div className="text-muted small">Kit Type</div>
                    <Form.Label className="text-capitalize">{kitData?.kitType}</Form.Label>
                  </Col>
                }
                {kitData?.siteName &&
                  <Col xs={6} className="mt-2">
                    <div className="text-muted small">Depot-Site</div>
                    <Form.Label className="text-capitalize">{kitData?.depot}{kitData?.siteName}</Form.Label>
                  </Col>
                }
                {kitData?.batchNumber &&
                  <Col xs={6} className="mt-2">
                    <div className="text-muted small">Batch Number</div>
                    <Form.Label className="text-capitalize">{kitData?.batchNumber}</Form.Label>
                  </Col>
                }
                {kitData?.treatment &&
                  <Col xs={6} className="mt-2">
                    <div className="text-muted small">Treatment</div>
                    <Form.Label className="text-capitalize">
                      {(eiwrsPermission?.liveTreatmentUnblinded || eiwrsPermission?.qcTreatmentUnblinded || eiwrsPermission?.dbpTreatmentUnblinded) ?
                        kitData?.treatment
                        :
                        <Badge style={{ width: 70 }} className="bg-danger hstack gap-1"><FaLock /> Blinded</Badge>
                      }
                    </Form.Label>
                  </Col>
                }
                {kitData?.expiryDate &&
                  <Col xs={6} className="mt-2">
                    <div className="text-muted small">Expiry Date</div>
                    <Form.Label className="text-capitalize">{kitData?.expiryDate}</Form.Label>
                  </Col>
                }
                {columns?.map((item) => {
                  const columnData = (kitData?.columns || [])?.find(
                    (ele) => ele?.columnName === item?.columnName
                  );
                  return (
                    <Col xs={6} className="mt-2">
                      <Form.Label className="text-muted small">{item?.columnLabel}</Form.Label>
                      <Form.Label className="text-capitalize">{columnData?.columnValue || ""}</Form.Label>
                    </Col>
                  );
                })}
                {kitData?.QCComment &&
                  <Col xs={12} className="mt-2">
                    <div className="text-muted small">QC Comment</div>
                    <Form.Label className="text-capitalize">{kitData?.QCComment}</Form.Label>
                  </Col>
                }
                <Form.Group className="mt-3">
                  <div className="text-muted small mb-2">QC Check List</div>
                  <Form.Check
                    type="checkbox"
                    label="Label verification"
                    disabled
                    checked={kitData?.QCChecklist?.labelVerification}
                  />

                  <Form.Check
                    type="checkbox"
                    label="Kit content verification"
                    disabled
                    checked={kitData?.QCChecklist?.kitContentVerification}
                  />

                  <Form.Check
                    type="checkbox"
                    label="Batch & lot verification"
                    disabled
                    checked={kitData?.QCChecklist?.batchLotVerification}
                  />

                  <Form.Check
                    type="checkbox"
                    label="Expiry verification"
                    disabled
                    checked={kitData?.QCChecklist?.expiryVerification}
                  />

                  <Form.Check
                    type="checkbox"
                    label="Tamper seal verification"
                    disabled
                    checked={kitData?.QCChecklist?.tamperSealVerification}
                  />

                  <Form.Check
                    type="checkbox"
                    label="Barcode scan verification"
                    disabled
                    checked={kitData?.QCChecklist?.barcodeScanVerification}
                  />
                </Form.Group>
                {kitData?.certificateofAnalysisRef &&
                  <Col xs={6} className="mt-2">
                    <div className="text-muted small">Certificate of Analysis Ref</div>
                    <Form.Label className="text-capitalize">{kitData?.certificateofAnalysisRef}</Form.Label>
                  </Col>
                }
                {kitData?.certificateofReleaseRef &&
                  <Col xs={6} className="mt-2">
                    <div className="text-muted small">Certificate of Release Ref</div>
                    <Form.Label className="text-capitalize">{kitData?.certificateofReleaseRef}</Form.Label>
                  </Col>
                }
                {kitData?.releaseComment &&
                  <Col xs={12} className="mt-2">
                    <div className="text-muted small">Released Comment</div>
                    <Form.Label className="text-capitalize">{kitData?.releaseComment}</Form.Label>
                  </Col>
                }
                {kitData?.quarantinedReason &&
                  <Col xs={6} className="mt-2">
                    <div className="text-muted small">Quarantined Reason</div>
                    <Form.Label className="text-capitalize">{kitData?.quarantinedReason}</Form.Label>
                  </Col>
                }
                {kitData?.investigationNumber &&
                  <Col xs={6} className="mt-2">
                    <div className="text-muted small">Investigation Number</div>
                    <Form.Label className="text-capitalize">{kitData?.investigationNumber}</Form.Label>
                  </Col>
                }
                {kitData?.quarantinedComment &&
                  <Col xs={12} className="mt-2">
                    <div className="text-muted small">Quarantined Comment</div>
                    <Form.Label className="text-capitalize">{kitData?.quarantinedComment}</Form.Label>
                  </Col>
                }
              </Row>
            </Card.Body>
          </Card>
          {!(kitData?.quarantined || kitData?.status === "dispensed") &&
            <>
              <Form.Group className="mb-1">
                <div className="hstack gap-2">
                  <Form.Label className="fw-bold mb-1">
                    Quarantined Reason{" "}
                    <abbr title="Required" className="text-danger">
                      *
                    </abbr>
                  </Form.Label>
                  <Badge onClick={() => { setReasonType(reasonType === "dynamic" ? "custom" : "dynamic"); setQuarantinedReason("") }} bg="primary" className="mb-1 text-capitalize CP rounded-1" style={{ fontSize: 9 }}>{reasonType === "dynamic" ? "custom" : "dynamic"}</Badge>
                </div>
                {reasonType === "dynamic" ?
                  <Form.Select
                    onChange={(e) => setQuarantinedReason(e.target.value)}
                    style={{ fontSize: 12 }}
                    className="br3"
                    value={quarantinedReason}
                  >
                    <option value="">Select Quarantine Reason</option>
                    {reasonList?.map((item => (
                      <option value={item?.reason}>
                        {item?.reason}
                      </option>
                    )))}
                  </Form.Select>
                  :
                  <Form.Control
                    className="br3"
                    onChange={(e) => setQuarantinedReason(e.target.value)}
                    rows={3}
                    value={quarantinedReason}
                    placeholder="Enter Quarantine Reason"
                    as="textarea"
                  />
                }
              </Form.Group>
              <Form.Group className="mb-1">
                <Form.Label className="fw-bold mb-1">
                  Investigation Number
                </Form.Label>
                <Form.Control
                  value={investigationNumber}
                  onChange={(e) => setInvestigationNumber(e.target.value)}
                  className="br3"
                  placeholder="Enter Investigation Number"
                  type="text"
                />
              </Form.Group>
              <Form.Group className="mb-1">
                <Form.Label className="fw-bold mb-1">
                  Quarantined Comment
                </Form.Label>
                <Form.Control
                  value={quarantinedComment}
                  onChange={(e) => setQuarantinedComment(e.target.value)}
                  className="br3"
                  placeholder="Enter Comment"
                  as="textarea"
                />
              </Form.Group>
            </>
          }
        </Offcanvas.Body>
        {kitData?.status !== "dispensed" &&
          <div className="p-2 bg-light border-top shadow-sm text-end">
            {!kitData?.quarantined ?
              <button
                disabled={!quarantinedReason || buttonLoader}
                className="updateProfile"
                onClick={(e) => statusQuarantinedConvertKitPreparation(e)}
              >
                {buttonLoader ? (
                  <div className="hstack gap-2">
                    <Spinner size="sm" /> Quarantining...
                  </div>
                ) : (
                  "Quarantine Kit"
                )}
              </button>
              :
              <button
                disabled={buttonLoader}
                className="updateProfile"
                onClick={(e) => statusReleasedQuarantinedConvertKitPreparation(e)}
              >
                {buttonLoader ? (
                  <div className="hstack gap-2">
                    <Spinner size="sm" /> Releasing...
                  </div>
                ) : (
                  "Release from Quarantine"
                )}
              </button>
            }
          </div>
        }
      </Offcanvas>
    </>
  );
};

export default QuarantinedKitPreparation;
